import React from 'react';

const STATUS_STYLES = {
  pending: { bg: 'rgba(212,165,32,0.15)', text: '#B8860B', label: 'Pending' },
  approved: { bg: 'rgba(5,150,105,0.15)', text: '#059669', label: 'Approved' },
  rejected: { bg: 'rgba(220,38,38,0.15)', text: '#DC2626', label: 'Rejected' },
  under_review: { bg: 'rgba(11,31,59,0.1)', text: '#0B1F3B', label: 'Under Review' },
};

const FLASH_COLORS = {
  green: 'rgba(5,150,105,0.12)',
  red: 'rgba(220,38,38,0.1)',
  navy: 'rgba(11,31,59,0.1)',
};

export default function ApplicationsTable({ applications, onSelect, selectedId, flashRows }) {
  if (applications?.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-100 p-16 flex flex-col items-center justify-center">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: 'rgba(212,165,32,0.1)' }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path d="M9 12h6M9 16h6M9 8h6M5 4h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1z" stroke="#D4A520" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <p className="text-base font-semibold" style={{ color: '#0B1F3B' }}>No applications found</p>
        <p className="text-sm mt-1" style={{ color: '#9CA3AF' }}>Applications will appear here once submitted</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr style={{ background: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
              {['Applicant', 'Business', 'Sector', 'Stage', 'Ask Amount', 'Submitted', 'Status', '']?.map(h => (
                <th key={h} className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider" style={{ color: '#6B7280' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {applications?.map((app, i) => {
              const status = STATUS_STYLES?.[app?.status] || STATUS_STYLES?.pending;
              const isSelected = app?.id === selectedId;
              const flashColor = flashRows?.[app?.id];
              return (
                <tr
                  key={app?.id}
                  className="cursor-pointer transition-colors hover:bg-[#D4A520]/5"
                  style={{
                    borderBottom: i < applications?.length - 1 ? '1px solid #F3F4F6' : 'none',
                    background: flashColor
                      ? FLASH_COLORS?.[flashColor]
                      : isSelected
                      ? 'rgba(212,165,32,0.08)'
                      : 'white',
                    transition: 'background 0.5s ease',
                  }}
                  onClick={() => onSelect(app)}
                >
                  <td className="px-4 py-4">
                    <div className="flex items-center gap-3">
                      {app?.profile_photo_url ? (
                        <img src={app?.profile_photo_url} alt={app?.founder_name} className="w-9 h-9 rounded-full object-cover flex-shrink-0" />
                      ) : (
                        <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-sm" style={{ background: '#0B1F3B', color: '#D4A520' }}>
                          {app?.founder_name?.charAt(0)?.toUpperCase()}
                        </div>
                      )}
                      <div>
                        <p className="text-sm font-semibold" style={{ color: '#0B1F3B' }}>{app?.founder_name}</p>
                        <p className="text-xs" style={{ color: '#9CA3AF' }}>{app?.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <p className="text-sm font-medium" style={{ color: '#0B1F3B' }}>{app?.business_name}</p>
                    {app?.website_url && <p className="text-xs truncate max-w-[120px]" style={{ color: '#9CA3AF' }}>{app?.website_url}</p>}
                  </td>
                  <td className="px-4 py-4">
                    <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium" style={{ background: 'rgba(11,31,59,0.08)', color: '#0B1F3B' }}>
                      {app?.sector}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span className="text-sm" style={{ color: '#374151' }}>{app?.funding_stage}</span>
                  </td>
                  <td className="px-4 py-4">
                    <span className="text-sm font-semibold" style={{ color: '#0B1F3B' }}>
                      {app?.min_investment ? `$${Number(app?.min_investment)?.toLocaleString()}` : '—'}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span className="text-xs" style={{ color: '#6B7280' }}>
                      {app?.submitted_at ? new Date(app.submitted_at)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span
                      className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold"
                      style={{
                        background: status?.bg,
                        color: status?.text,
                        transition: 'background 0.4s ease, color 0.4s ease',
                      }}
                    >
                      {status?.label}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <button
                      className="px-3 py-1.5 rounded-lg text-xs font-bold transition-colors hover:opacity-80"
                      style={{ background: '#0B1F3B', color: '#D4A520' }}
                      onClick={(e) => { e?.stopPropagation(); onSelect(app); }}
                    >
                      Review
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
